// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Paginado_arrow__17X1N","pagActual":"Paginado_pagActual__1NkcR","pagOther":"Paginado_pagOther__2Fmjy"};